module.exports = __webpack_public_path__ + "img/three.822a4192.png";